import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import LoadingButton from '@mui/lab/LoadingButton'
import { Grid, Button, Paper, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import PasswordField from 'components/UserFields/PasswordField'
import SaveIcon from '@mui/icons-material/Save'
import { fetchUpdatePassword } from 'src/redux/employerUser'

const Security = ({ employerUser }) => {
  const [readOnly, setReadOnly] = React.useState(true)
  const dispatch = useDispatch()
  const [values, setValues] = React.useState({})
  const [errors, setErrors] = React.useState({})
  const user = useSelector(state => state.user)
  const loading = employerUser.loading

  const setDefaultValues = () => {
    if (Object.keys(employerUser.errors).length > 0) {
      Object.keys(employerUser.errors).map(key => {
        setErrors({ ...errors, [key]: employerUser.errors[key][0] })
      })
    }
  }

  React.useEffect(() => {
    if (!employerUser.loading) {
      setDefaultValues()
    }
  }, [employerUser])

  const handleEditClick = () => {
    setReadOnly(false)
  }

  const handleChange = event => {
    setValues({ ...values, [event.target.name]: event.target.value })
  }

  const handleSubmit = () => {
    dispatch(fetchUpdatePassword({ ...values, id: user.id }))
  }

  const handleCancelClick = () => {
    setReadOnly(true)
  }

  return (
    <Grid
      container
      direction='column'
      justifyContent='flex-start'
      sx={{
        marginBottom: '50px',
        backgroundColor: 'transparent',
        padding: '50px'
      }}
    >
      <Grid container direction='row' justifyContent='space-between' item>
        <Grid container item justifyContent='flex-start'>
          {readOnly ? (
            <Button
              variant='contained'
              size='small'
              onClick={handleEditClick}
              startIcon={<EditIcon />}
            >
              Update Password
            </Button>
          ) : (
            <Grid item>
              <Button size='small' sx={{ marginRight: '20px' }} onClick={handleCancelClick}>
                Cancel
              </Button>
              <LoadingButton
                variant='contained'
                size='small'
                onClick={handleSubmit}
                startIcon={<SaveIcon />}
                loading={loading}
                disabled={
                  Object.keys(errors).length > 0 ||
                  !values.currentPassword ||
                  !values.password ||
                  !values.confirmPassword
                }
              >
                Save Password
              </LoadingButton>
            </Grid>
          )}
        </Grid>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mt: 3,
            width: '100%',
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'background.default'
          }}
        >
          <Typography variant="subtitle1" sx={{ mb: 3, fontWeight: 500 }}>
            Password Settings
          </Typography>
          <PasswordField
            handleChange={handleChange}
            values={values}
            errors={errors}
            disabled={readOnly}
            setErrors={setErrors}
          />
        </Paper>
      </Grid>
    </Grid>
  )
}

export default Security
